var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SUCCESS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-141.38 0-256 114.58-256 256s114.62 256 256 256 256-114.65 256-256-114.62-256-256-256z",
    fill: "#2ad352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 256a254.87 254.87 0 0 0 30.49 121.23 278.76 278.76 0 0 0 78.73 11.29c153.9 0 278.66-124.76 278.66-278.66a278.7 278.7 0 0 0 -11.64-79.94 254.86 254.86 0 0 0 -120.24-29.92c-141.38 0-256 114.58-256 256z",
    fill: "#74da7f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402 213.58-153.87 161.59a45.16 45.16 0 0 1 -32.48 14h-.2a45.11 45.11 0 0 1 -32.4-13.71l-81.65-84.1a45.14 45.14 0 1 1 64.78-62.87l48.95 50.42 121.49-127.58a45.14 45.14 0 1 1 65.38 62.25z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.388f9a3489caea4becdfab2c6f698c20.svg";
export { ForwardRef as ReactComponent };